<template>
  <div>
    <div class="pt-5"></div>
    <v-toolbar card color="white">
      <v-toolbar-title>Tickets</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-text-field
        solo
        hide-details
        prepend-inner-icon="search"
        placeholder="Tìm trên danh sách này"
        v-model="keyword"
      ></v-text-field>
      <v-tooltip bottom>
        <v-btn icon slot="activator" @click="exportToExcel()">
          <v-icon>save_alt</v-icon>
        </v-btn>
        <span>Tải về</span>
      </v-tooltip>
    </v-toolbar>
    <v-divider></v-divider>
    <v-data-table
      item-key="id"
      disable-initial-sort
      :headers="table.headers"
      :items="datasourceFiltered"
      :rows-per-page-items="[5,10,20,50]"
      :loading="isLoading"
    >
      <template slot="items" slot-scope="props">
        <tr @click="viewMore(props.item)" class="table-row">
          <td>{{ props.item.TicketCode }}</td>
          <td style="min-width: 130px">{{ props.item.Type }}</td>
          <td class="no-wrap">{{ props.item.Vehicle }}</td>
          <td>{{ props.item.TrackingIds && props.item.TrackingIds.split(",").join(", ") }}</td>
          <td class="no-wrap">{{ truncate(props.item.WorkLog) }}</td>
          <td class="no-wrap">{{props.item.Description }}</td>
          <td class="no-wrap">{{ props.item.CreatedTime }}</td>
          <td class="no-wrap">{{ props.item.PlanTime }}</td>
          <td class="no-wrap">{{ props.item.FinishedTime }}</td>
          <td class="no-wrap">{{ props.item.RepairPersons }}</td>
          <td class="no-wrap">{{ props.item.FirstSupport }}</td>
          <td class="no-wrap">{{ props.item.SecondSupport }}</td>
          <td class="no-wrap">{{ props.item.ThirdSupport }}</td>
          <td class="no-wrap">{{ props.item.Status }}</td>
        </tr>
      </template>
    </v-data-table>
    <!-- Dialog -->
    <div class="text-xs-center">
      <v-dialog v-model="isShowWorkLog" max-width="1024" transition="false">
        <ticket-detail :ticket="selectedTicket"/>
      </v-dialog>
    </div>
    <!-- End Dialog -->
  </div>
</template>

<script>
import validate from '@/utils/validate';
import { mapGetters } from 'vuex';
import TicketDetail from '@/components/crm/TicketDetail';
import { formatGMTToLocalTime } from '@/utils/datetime';
import XLSX from 'xlsx';

export default {
  components: {
    TicketDetail
  },
  props: {
    name: String,
    datasource: Array,
    isLoading: Boolean
  },
  data () {
    return {
      table: {
        headers: [
          {
            text: 'Ticket Code',
            value: 'TicketCode'
          },
          {
            text: 'Type',
            value: 'Type'
          },
          {
            text: 'Vehicle',
            value: 'Vehicle'
          },
          {
            text: 'TrackingIds',
            value: 'TrackingIds'
          },
          {
            text: 'WorkLog',
            value: 'WorkLog'
          },
          {
            text: 'Description',
            value: 'Description'
          },
          {
            text: 'Created',
            value: 'Created'
          },
          {
            text: 'Plan',
            value: 'Plan'
          },
          {
            text: 'Finished',
            value: 'Finished'
          },
          {
            text: 'RepairPerson',
            value: 'RepairPerson'
          },
          {
            text: 'BPHT1',
            value: 'FirstSupport'
          },
          {
            text: 'BPHT2',
            value: 'SecondSupport'
          },
          {
            text: 'BPHT3',
            value: 'ThirdSupport'
          },
          {
            text: 'Status',
            value: 'Status'
          }
        ]
      },
      datasourceFiltered: [],
      keyword: '',
      selectedTicket: {},
      isShowWorkLog: false
    };
  },
  computed: {
    ...mapGetters(['searchText'])
  },
  watch: {
    datasource () {
      this.search();
    },
    keyword () {
      this.search();
    }
  },
  created () {
    if (!this.searchText.startsWith('/')) {
      // this.keyword = this.searchText;
    }
  },
  methods: {
    formatGMTToLocalTime,
    search () {
      let keywordRemovedVietnamese = validate.transferVietnamese(
        this.keyword.toLowerCase()
      );
      this.datasourceFiltered = this.datasource
        .filter(a =>
          validate
            .transferVietnamese(
              (
                a.Vehicle +
                a.TicketCode +
                a.TrackingIds +
                a.WorkLog +
                a.Plan +
                a.Finished +
                a.RepairPerson +
                a.Status +
                a.FirstName + a.LastName
              ).toLowerCase()
            )
            .includes(keywordRemovedVietnamese.toLowerCase())
        )
        .reverse();
    },
    truncate (text) {
      return text.substring(0, 30) + '...';
    },
    viewMore (c) {
      this.isShowWorkLog = true;
      this.selectedTicket = c;
    },
    exportToExcel () {
      if (this.datasourceFiltered.length === 0) {
        window.getApp.showMessage('Không có dữ liệu', 'error');
        return;
      }

      let sheet = XLSX.utils.json_to_sheet(this.datasourceFiltered);
      let wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, sheet, 'CrmTickets');
      XLSX.writeFile(wb, `Bitrix - CrmTickets.xlsx`);
    }
  }
};
</script>

<style>
.no-wrap {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/search/components/CrmTickets.vue